import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import chatService from "../services/chat";

const initialState = {
  history: [
    {
      role: 'assistant', 
      content: {
        resultDescription: 'How can I help you today?'
      }
    }
  ],
  hierarchy: [],
  source: '',
  session: '',
  cube: null,
  isAdminCredential: true
};

export const chatWithSQL = createAsyncThunk(
  "chat/sql",
  async (info) => {
    const res = await chatService.chat(info);
    return res.data;
  }
);

export const getHierarchy = createAsyncThunk(
  "chat/hierarchy",
  async () => {
    const res = await chatService.getHierarchy();
    return res.data;
  }
);

export const getHistory = createAsyncThunk(
  "chat/history",
  async (info) => {
    const res = await chatService.getHistory(info);
    return res.data;
  }
)

export const getCubeHistory = createAsyncThunk(
  "chat/cube_history",
  async (info) => {
    const res = await chatService.getCubeHistory(info);
    return res.data;
  }
)

export const saveSession = createAsyncThunk(
  "chat/save_session",
  async (info) => {
    const res = await chatService.saveSession(info);
    return res.data;
  }
)

export const renameSession = createAsyncThunk(
  "chat/rename_session",
  async (info) => {
    const res = await chatService.renameSession(info);
    return res.data;
  }
)

export const removeSession = createAsyncThunk(
  "chat/remove_session",
  async (info) => {
    const res = await chatService.removeSession(info);
    return res.data;
  }
)

export const parseQuery = createAsyncThunk(
  "chat/parse_query",
  async (info) => {
    const res = await chatService.parseQuery(info);
    return res.data;
  }
)


const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setSession: (state, action) => {
      const { source, session, cube, isAdminCredential } = action.payload;
      state.source = source;
      state.session = session;
      state.cube = cube || null;
      state.isAdminCredential = isAdminCredential;
    },
    formatHistory: (state, action) => {
      state.history = [
        {
          role: 'assistant', 
          content: {
            resultDescription: 'How can I help you today?'
          }
        }
      ]
    },
    formatSession: (state, action) => {
      state.session = ''
    },
    updateHistory: (state, action) => {
      state.history = action.payload
    }
 },
  extraReducers: (builder) => {
    builder.addCase(chatWithSQL.fulfilled, (state, action) => {
      // state.history = action.payload
    })
    builder.addCase(getHierarchy.fulfilled, (state, action) => {
      state.hierarchy = action.payload
    })
    builder.addCase(getHistory.fulfilled, (state, action) => {
      const jsonStr = action.payload
      state.history = JSON.parse(jsonStr);
    })
    builder.addCase(getCubeHistory.fulfilled, (state, action) => {
      const jsonStr = action.payload
      state.history = JSON.parse(jsonStr);
    })
    builder.addCase(saveSession.fulfilled, (state, action) => {
      console.log(action.payload)
    })
    builder.addCase(renameSession.fulfilled, (state, action) => {
      console.log(action.payload)
    })
    builder.addCase(removeSession.fulfilled, (state, action) => {
      console.log(action.payload)
    })
  }
});

export const {
  setSession,
  formatHistory,
  formatSession,
  updateHistory
} = chatSlice.actions;
const { reducer } = chatSlice;
export default reducer;